// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedTimesheet: null
}

const timesheets = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_TIMESHEETS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_TIMESHEETS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_TIMESHEET':
      return { ...state, selectedTimesheet: action.selectedTimesheet }
    case 'ADD_TIMESHEET':
      return { ...state }
    case 'DELETE_TIMESHEET':
      return { ...state }
    default:
      return { ...state }
  }
}
export default timesheets
